export const FETCHING_USER = "FECTHING_USER";
export const FETCHING_USER_DONE = "FETCHING_USER_DONE";
export const FAILED_FETCHING_USER = "FAILED FECTHING";
